import Text, {TextProps} from './text';

export default Text;
export type {TextProps};
